import './styles/graphic.scss';
import data from './data/data.json';

export default function (props, container, isMobile) {
  const width = 250;
  const spacing = 8;
  const maxWidth = width * data.length;
  const scrollAmount = isMobile ? 1 : 2;

  const wrapper = container.append('div')
    .attr('class', 'module-wrapper');

  const items = wrapper.append('div')
    .attr('class', 'modules')
    .style('width', `${maxWidth}px`);

  const item = items.selectAll('div')
    .data(data)
    .enter().append('a')
    .attr('class', 'module')
    .attr('target', '_blank')
    .attr('href', d => d.link)
    .attr('rel', 'noreferrer noopener')
    .html(d => `
      <div class='module-photo'>
        <img src='${d.photo}' />
      </div>
      <div class='module-text'>
        <h3>${d.headline}</h3>
      </div>
    `);

  const btns = container.selectAll('div.button')
    .data(['back', 'forward'])
    .enter().append('div')
    .attr('class', d => `${d} button`)
    .html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/><path d="M0 0h24v24H0z" fill="none"/></svg>')
    .on('click', clicked);

  function clicked(direction) {
    const back = direction === 'back';
    const node = wrapper.node();
    const { scrollLeft } = node;
    const distance = width * scrollAmount * (back ? -1 : 1);
    const advancement = scrollLeft + distance;
    const rounded = Math.floor(advancement / distance) * distance;

    const greaterThanMax = advancement >= maxWidth - width;
    const lessThanMin = scrollLeft <= width;

    if (greaterThanMax || (lessThanMin && scrollLeft !== 0 && back)) {
      // scroll to beginning

      node.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    } else if (scrollLeft <= 0 && back) {
      // scroll to end

      node.scroll({
        top: 0,
        left: maxWidth,
        behavior: 'smooth',
      });
    } else {
      // incremental
      const roundedValue = Math.floor(advancement / width) * width;

      node.scroll({
        top: 0,
        left: roundedValue,
        behavior: 'smooth',
      });
    }
  }
}
